<div class="admin-layout">
  <!-- Sidebar -->
  <aside class="sidebar" [class.collapsed]="!sidebarOpen">
    <div class="sidebar-header">
      <div class="brand">
        <mat-icon class="brand-icon">admin_panel_settings</mat-icon>
        <span class="brand-text" *ngIf="sidebarOpen">Aluguloo Admin</span>
      </div>
      <button class="toggle-btn" (click)="toggleSidebar()">
        <mat-icon>{{ sidebarOpen ? "menu_open" : "menu" }}</mat-icon>
      </button>
    </div>

    <nav class="sidebar-nav">
      <a
        class="nav-item"
        *ngFor="let item of menuItems"
        [routerLink]="item.route"
        routerLinkActive="active"
        (click)="navigateTo(item)"
        [title]="!sidebarOpen ? item.label : ''"
      >
        <mat-icon class="nav-icon" *ngIf="item.iconType === 'mat'">{{
          item.icon
        }}</mat-icon>
        <span class="nav-label" *ngIf="sidebarOpen">{{ item.label }}</span>
      </a>
    </nav>
  </aside>

  <!-- Main Area -->
  <div class="main-area">
    <!-- Top Navbar -->
    <header class="topbar">
      <div class="topbar-left">
        <span class="page-title">Admin Dashboard</span>
      </div>
      <div class="topbar-right">
        <span class="user-email">{{ currentusername || "Admin" }}</span>
        <button
          mat-icon-button
          [matMenuTriggerFor]="userMenu"
          class="profile-btn"
        >
          <mat-icon>account_circle</mat-icon>
        </button>
        <mat-menu #userMenu="matMenu">
          <button mat-menu-item (click)="signOut()">
            <mat-icon>logout</mat-icon>
            <span>Sign Out</span>
          </button>
        </mat-menu>
      </div>
    </header>

    <!-- Page Content -->
    <main class="page-content">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
